<ng-container *ngIf="windowHash; else noModal">
  <!-- cabecera para acciones de tareas en modo modal -->
  <sub-header [isModal]="true" [includeContextHelp]="true" [windowHash]="windowHash">
  </sub-header>
  <ng-container *ngTemplateOutlet="dlgTemplates"></ng-container>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1 projectInHeader">
    <ng-container *ngTemplateOutlet="templateAssignment"></ng-container>
  </p-scrollPanel>
</ng-container>
<ng-template #noModal>
  <div class="wrapper wrapper-content">
    <ng-container *ngTemplateOutlet="dlgTemplates"></ng-container>
    <ng-container *ngTemplateOutlet="templateAssignment"></ng-container>
  </div>
</ng-template>
<ng-template #dlgTemplates>
  <ng-container *ngTemplateOutlet="loadProtocolDlg"></ng-container>
  <ng-container *ngTemplateOutlet="saveOptionsDlg"></ng-container>
  <ng-container *ngTemplateOutlet="deteleHistoryDlg"></ng-container>
</ng-template>
<ng-template #templateAssignment>
  <div class="container-fluid">
    <div class="row" *ngIf="this.context?.manageCurrentProcedure?.value">
      <ng-container>
        <div class="col-3"><span class="font-bold m-r-md">{{'TaskAssignment.procedure' | translate}}</span></div>
        <div class="col-9">{{assignment?.selectedProcedure?.description}}</div>
      </ng-container>
    </div>
    <div class="row mt-3" *ngIf="isVisibleReassignByProfiles">
      <div class="col-3"><label for="reassignByProfileCheck" class="font-bold ">{{'TaskAssignment.reassignByProfiles' |
          translate}}</label>
      </div>
      <div class="col-9">
        <p-checkbox [binary]="true" class="align-middle col-1 p-0" [(ngModel)]="reassignByProfiles"
          inputId="reassignByProfileCheck">
        </p-checkbox>
        <span *ngIf="reassignByProfiles" class="alert alert-info">
          <i class="fas fa-1-5x fa-info-circle align-middle m-r-xs" aria-hidden="true"></i>
          <span class="align-middle">{{'TaskAssignment.checkWarn' | translate}}</span>
        </span>
      </div>
    </div>
    <div class="row p-3 m-t-xs">
      <div class="col-12">
        <p-table [value]="profiles" sortField="order" [responsive]="true"  [reorderableColumns]="true" [scrollable]="false"
          >
          <ng-template pTemplate="header">
            <tr>
              <th [style.width]="'8%'" *ngIf="reassignByProfiles">{{ colHeaders[0] | translate }}</th>
              <th [style.width]="'20%'">{{ colHeaders[1] | translate }}</th>
              <th [style.width]="'36%'">{{ colHeaders[2] | translate }}</th>
              <th [style.width]="'36%'">{{ colHeaders[3] | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
            <tr>
              <td *ngIf="reassignByProfiles">
              <span class="p-column-title">{{ colHeaders[0] | translate }}</span>
                <p-checkbox [binary]="true" class="col-1 p-0 ml-2 mb-2" [(ngModel)]="data.checked"></p-checkbox>
              </td>
              <td>
              <span class="p-column-title">{{ colHeaders[1] | translate }}</span> {{ data.profile?.description }}
              </td>
              <td>
              <span class="p-column-title">{{ colHeaders[2] | translate }}</span>
                <formElement [model]="data.dispatcher" [fieldConfig]="getFieldConfigDispatcher(data)"
                  [inlineComponent]="true" (valueChanged)="assignmentChanged(data.dispatcher, false, $event)"
                  [functions]="functions">
                </formElement>
              </td>
              <td>
              <span class="p-column-title">{{ colHeaders[3] | translate }}</span>
                <formElement [model]="data.signer" [fieldConfig]="getFieldConfigSigner(data)" [inlineComponent]="true"
                  (valueChanged)="assignmentChanged(data.signer, true, $event)" [functions]="functions">
                </formElement>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td colspan="3">{{ 'General.noData' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #loadProtocolDlg>
  <p-dialog header="{{ 'General.select' | translate}}" [(visible)]="displayLoadProtocol" styleClass="w-75"
    [modal]="true">
    <div class="row" *ngIf="context?.isVisibleSearchOrganizationalUnit?.value">
      <div class="col-12">
        <span class="font-bold m-r-md">{{'TaskAssignment.protocol.unit' | translate }}</span>
        <formElement [model]="organizationalUnitModel" [fieldConfig]="getFieldConfigUO()" [inlineComponent]="true">
        </formElement>
      </div>
    </div>
    <div class="row m-t-xs" *ngIf="!context?.isVisibleSearchOrganizationalUnit?.value">
      <div class="col-2">
        <span class="font-bold m-r-md">{{'TaskAssignment.protocol.unit' | translate }}</span>
      </div>
      <div class="col-10">{{ organizationalUnitModel.organizationalUnit?.name }}</div>
    </div>
    <div class="col-12 m-t-md"> {{'TaskAssignment.options.message' | translate }} </div>
    <div class="row m-t-xs">
      <div class="col-12">
        <p-radioButton name="overrideAllWithProtocol" [inputId]="protocolOverrideEmpty" [value]="false"
          [(ngModel)]="overrideAllWithProtocol">
        </p-radioButton>
        <label for="protocolOverrideEmpty" class="ml-2">{{'TaskAssignment.protocol.options.empty' | translate }}</label>
      </div>
    </div>
    <div class="row m-t-xs">
      <div class="col-12">
        <p-radioButton name="overrideAllWithProtocol" [inputId]="protocolOverrideAll" [value]="true"
          [(ngModel)]="overrideAllWithProtocol">
        </p-radioButton>
        <label for="protocolOverrideAll" class="ml-2">{{'TaskAssignment.protocol.options.all' | translate }}</label>
      </div>
    </div>
    <div class="row m-t-md m-b-md">
      <div class="col-12 d-flex justify-content-center">
        <div class="btn-group-xs">
          <button class="m-l-sm btn btn-secondary btn-sm" appNoDblClick (click)="loadProtocol(overrideAllWithProtocol)"
            type="button"> {{'General.accept' | translate }}</button>
          <button class="m-l-sm btn btn-primary btn-sm" appNoDblClick (click)="closeProtocolWindow()" type="button">
            {{'General.cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-template>
<ng-template #saveOptionsDlg>
  <p-dialog header="{{ 'General.select' | translate}}" [modal]="true" [baseZIndex]="3" [(visible)]="displaySaveOptions"
    styleClass="w-75">
    <div class="row">
      <div class="col-12"> {{'TaskAssignment.options.message' | translate }} </div>
    </div>
    <div class="row m-t-xs" *ngIf="this.context?.manageCurrentProcedure?.value">
      <div class="col-12">
        <p-radioButton name="reassignActionType" [inputId]="ReassignActionType.SELECTED_PROCEDURE"
          [value]="ReassignActionType.SELECTED_PROCEDURE" [(ngModel)]="this.reassignActionType"></p-radioButton>
        <label for="ReassignActionType.SELECTED_PROCEDURE" class="ml-2">{{
          'TaskAssignment.ReassignActionType.SELECTED_PROCEDURE' | translate}}</label>
      </div>
    </div>
    <div class="row m-t-xs" *ngIf="this.context?.manageCurrentProcedure?.value">
      <div class="col-12">
        <p-radioButton name="reassignActionType" [inputId]="ReassignActionType.NEW_AND_SELECTED_PROCEDURE"
          [value]="ReassignActionType.NEW_AND_SELECTED_PROCEDURE" [(ngModel)]="this.reassignActionType">
        </p-radioButton>
        <label for="ReassignActionType.NEW_AND_SELECTED_PROCEDURE" class="ml-2">{{
          'TaskAssignment.ReassignActionType.NEW_AND_SELECTED_PROCEDURE' | translate}}</label>
      </div>
    </div>
    <div class="row m-t-xs" *ngIf="!this.context?.manageCurrentProcedure?.value">
      <div class="col-12">
        <p-radioButton name="reassignActionType" [inputId]="ReassignActionType.NEW_PROCEDURE"
          [value]="ReassignActionType.NEW_PROCEDURE" [(ngModel)]="this.reassignActionType">
        </p-radioButton>
        <label for="ReassignActionType.NEW_PROCEDURE" class="ml-2">{{ 'TaskAssignment.ReassignActionType.NEW_PROCEDURE'
          | translate}}</label>
      </div>
    </div>
    <div class="row m-t-xs">
      <div class="col-12">
        <p-radioButton name="reassignActionType" [inputId]="ReassignActionType.ALL_PROCEDURE"
          [value]="ReassignActionType.ALL_PROCEDURE" [(ngModel)]="this.reassignActionType">
        </p-radioButton>
        <label for="ReassignActionType.ALL_PROCEDURE" class="ml-2">{{ 'TaskAssignment.ReassignActionType.ALL_PROCEDURE'
          | translate}}</label>
      </div>
    </div>
    <div class="row  m-b-md m-t-md">
      <div class="col-12 d-flex justify-content-center">
        <div class="btn-group-xs">
          <button class="m-l-sm btn btn-secondary btn-sm" appNoDblClick (click)="saveOptions()" type="button">
            {{'General.save' | translate }}</button>
          <button class="m-l-sm btn btn-primary btn-sm" appNoDblClick (click)="this.displaySaveOptions = false"
            type="button"> {{'General.cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-template>
<ng-template #deteleHistoryDlg>
  <p-dialog header="{{ 'General.select' | translate}}" [(visible)]="displayDeleteHistory" styleClass="w-75"
    [modal]="true">
    <div class="row">
      <div class="col-12"> {{'TaskAssignment.confirmation.delete' | translate }} </div>
    </div>
    <div class="row m-b-md m-t-xs">
      <div class="col-12 d-flex justify-content-center">
        <div class="btn-group-xs">
          <button class="m-l-sm btn btn-secondary btn-sm" appNoDblClick (click)="this.save(true)" type="button">
            {{'TaskAssignment.buttons.delete' | translate }}</button>
          <button class="m-l-sm btn btn-secondary btn-sm" appNoDblClick (click)="this.save()" type="button">
            {{'TaskAssignment.buttons.nodelete' | translate }}</button>
          <button class="m-l-sm btn btn-primary btn-sm" appNoDblClick (click)="this.displayDeleteHistory = false"
            type="button"> {{'General.cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-template>